$(document).ready(function(){

  // Footer
  $('.footer .footer-block--menu h2').click(function(){
    $(this).toggleClass('active');
    $(this).parent().find('ul.footer-block__details-content').slideToggle();    
  });

  $('.size_toggle').click(function(){
    $(".size_chart_main").show();  
    $('body,html').addClass("overflow_hidden");
  });

  $('.size_chart_close').click(function(){
    $(".size_chart_main").hide();    
    $('body,html').removeClass("overflow_hidden");
  });

  $(document).mouseup(function(e){
    var container = $(".size-chart-container");
    if(!container.is(e.target) && container.has(e.target).length === 0){
      $(".size_chart_main").hide();    
      $('body,html').removeClass("overflow_hidden");
    }
  });

  $(document).on("click" , '.size_button', function(){
    var datatab = $(this).attr("datatab");
    console.log(datatab);
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    $(".size_table").hide();
    $(".size_table").removeClass("active");
    $(".size_table[datashow='" +datatab+ "']").show();
    $(".size_table[datashow='" +datatab+ "']").addClass("active");
  });
  
});

// header submenu show on mouse hover instead of click
let items = document.querySelector(".header-right-menu").querySelectorAll("details");
console.log(items)
items.forEach(item => {
  item.addEventListener("mouseover", () => {
  item.setAttribute("open", true);
  item.querySelector("ul").addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});
});

let Items = document.querySelector(".header__inline-menu").querySelectorAll("details");
Items.forEach(Item => {
  Item.addEventListener("mouseover", () => {
  Item.setAttribute("open", true);
  Item.querySelector("ul").addEventListener("mouseleave", () => {
    Item.removeAttribute("open");
  });
  Item.addEventListener("mouseleave", () => {
    Item.removeAttribute("open");
  });
});
});